//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
import draggable from "vuedraggable";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import setLabel from "@/components/Diagrams/config/set-label.vue";
import setDescription from "@/components/Diagrams/config/set-description.vue";
import notificationsPreview from "@/components/Diagrams/config/subcomponents/notifications-preview.vue";
import { eventBus, setPluginIcon } from "@/assets/js/appFunc";
import setRules from "@/components/Diagrams/config/set-rules.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";

export default {
    components: {
        draggable,
        AQModal,
        setLabel,
        setDescription,
        notificationsPreview,
        setRules,
        AQDropdown,
        AQButton,
        AQDialog,
        AQCard,
        AQCheckbox,
        AQRadio,
        AQTooltip,
        setNotifications: () => import(/* webpackChunkName: "setNotifications" */ "./set-notifications.vue"),
        setApprovalEvent: () => import(/* webpackChunkName: "setApprovalEvent" */ "@/components/Diagrams/config/set-approval-event.vue")
    },
    props: {
        uuid: {
            required: true,
            type: String
        },
        elementIndex: {
            type: Number,
            default: 0
        },
        readonly: {
            type: Boolean
        }
    },
    data() {
        return {
            initialConnectorData: {},
            resetSelectedTarget: false,
            modalOpened: false,
            firstLoadModal: false,
            saveEnabled: false,
            noEndpointsAvailable: false,
            allEndpointsAlreadySelected: false,
            showOutcomesContainer: false,
            showInfoMessage: "",
            noOutcomeSelected: false,
            outcomesAlreadyMapped: [],
            getOutcomePoints: [],
            outcomePointsFiltered: [],
            editedTarget: false,
            connectorData: {
                notifications: [],
                notificationRules: [],
                statusNameCode: {
                    statusCode: "",
                    statusName: ""
                },
                approvalDecision: [],
                previousOutcomes: [],
                submissionOption: "OPTIONAL"
            },
            activeConnector: null,
            showSetNotifications: false,
            notification: null,
            selectedConnectorInitialValue: null,
            targetSaved: false,
            fromConnector: true,
            targetDlg: false,
            preselectedTarget: false,
            headerActionsModel: [
                {
                    value: "deleteConnector",
                    label: this.$t("diagrams.components.setRules.delete")
                }
            ]
        };
    },
    validations: {
        connectorData: {
            approvalDecision: {
                required(v) {
                    return !!(this.selectedPluginCode !== "APPROVAL_PLUGIN" || (v && v.length));
                }
            }
        }
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData", "diagramConfigData", "selectedPluginCode", "selectedPluginUuid"]),
        ...mapGetters("apps", ["getDiagramExternalPlugins"]),
        addTargetDisabled() {
            return this.selectedPluginConfigData.pluginType === "BLOCKCHAIN_PLUGIN" && this.getConnectors.length >= 1;
        },
        errorOutcome() {
            const found = this.outcomePointsFiltered.find(el => this.connectorData.previousOutcomes.includes(el.value));

            return !this.showInfoMessage
                && ((!this.connectorData.previousOutcomes.length && this.activeConnector.previousOutcomes && !this.activeConnector.previousOutcomes.length)
                || this.allEndpointsAlreadySelected || this.noOutcomeSelected || !found);
        },
        setTargetValue() {
            return this.getObjects ? this.getObjects.filter(elem => elem.value === this.activeConnector.to.uuid) : "";
        },
        setOutcomeProcess() {
            return this.outcomePointsFiltered ? this.outcomePointsFiltered.filter(elem => this.activeConnector.previousOutcomes.includes(elem.value)) : [];
        },
        hasDone() {
            return {
                label: this.$t("generic.done"),
                disabled: (this.readonly || !this.saveEnabled)
            };
        },
        setHeaderActions() {
            return (this.showHeaderActions ? this.headerActionsModel : []);
        },

        getConnectors: {
            get() {
                const connectors = [];
                this.diagramConfigData.connectors.forEach(obj => {
                    if (obj.from === this.uuid) {
                        connectors.push({
                            ...obj,
                            label: obj.label || "",
                            to: { ...this.getToObjectConfig(obj.to) },
                            notifications: obj.notifications || [],
                            notificationRules: obj.notificationRules || [],
                            approvalDecision: obj.approvalDecision || [],
                            submissionOption: obj.submissionOption || "OPTIONAL",
                            submissionOrder: obj.submissionOrder || obj.submissionOrder === 0 ? obj.submissionOrder : Number.MAX_SAFE_INTEGER
                        });
                    }
                });
                connectors.sort((a, b) => a.submissionOrder - b.submissionOrder);
                return connectors;
            },
            set(v) {
                this.connectorOrderChanged(v);
                this.$emit("input", v);
            }

        },
        getObjects() {
            const objects = [];
            this.diagramConfigData.content.forEach(obj => {
                const selectInitialValue = this.selectedConnectorInitialValue
                && this.selectedConnectorInitialValue.to.uuid ? this.selectedConnectorInitialValue.to.uuid : null;
                const connected = this.getConnectors.find(el => el.to.uuid === obj.uuid);
                if ((obj.pluginType !== "GENERAL_START_PLUGIN" && obj.pluginType !== "EXTERNAL_SOURCE_PLUGIN"
                && obj.pluginType !== "START_BLOCKCHAIN_EVENT_PLUGIN"
                && obj.uuid !== this.uuid && (selectInitialValue === obj.uuid || !connected))) {
                    objects.push({
                        label: obj.label,
                        svgIcon: this.getTargetIcon(obj.pluginType),
                        value: obj.uuid
                    });
                }
            });
            return objects;
        },
        canAddMore() {
            return this.selectedPluginConfigData.pluginType !== "EXCLUSIVE_GATEWAY_PLUGIN"
            || (this.selectedPluginConfigData.pluginType === "EXCLUSIVE_GATEWAY_PLUGIN" && this.getConnectors.length < 2);
        },
        ddlSelect() {
            return {
                options: this.getObjects,
                defaultValue: this.currentValue(),
                resetSelectedData: this.resetSelectedTarget
            };
        },
        ddlOutcomeSelect() {
            return {
                options: this.outcomePointsFiltered,
                defaultValue: this.selectedPluginConfigData.process.processId ? this.activeConnector.previousOutcomes : [],
                hasCheckbox: true,
                isMultiselect: true
            };
        },
        computedModalTitle() {
            const secondTitle = this.activeConnector
            && this.activeConnector.uuid ? this.activeConnector.label : this.$t("diagrams.components.setTarget.newTarget");
            const title = `${this.selectedPluginConfigData.label}/${secondTitle || this.$t("diagrams.components.setTarget.untitledConnector")}`;
            return title;
        },
        showHeaderActions() {
            return this.readonly ? !this.readonly : !!this.activeConnector.to.uuid;
        },
        canAddTargetForDT() {
            let showAddTarget = true;
            const checkForDynamicPlugin = () => {
                const { activities, events, gateways } = this.getDiagramExternalPlugins || {};
                const dynamicPluginList = [...activities, ...events, ...gateways];
                const plugin = dynamicPluginList.find(el => el.id === this.selectedPluginConfigData.pluginType);
                if (plugin) {
                    showAddTarget = this.getConnectors.length < plugin.output;
                }
            };
            if (this.selectedPluginConfigData.pluginType === "ADVANCED_LOGIC_PLUGIN") {
                showAddTarget = !this.getConnectors.length;
            } else {
                checkForDynamicPlugin();
            }
            return showAddTarget;
        },
        isHumanTask() {
            return ["TASK_PLUGIN", "EXTERNAL_PLUGIN"].includes(this.selectedPluginCode);
        }
    },
    watch: {
        activeConnector(v) {
            if (v) {
                this.connectorData.notifications = v.notifications || [];
                this.connectorData.notificationRules = v.notificationRules || [];
                this.connectorData.statusNameCode = v.statusNameCode || {
                    statusCode: "",
                    statusName: ""
                };
                this.connectorData.approvalDecision = v.approvalDecision || [];
                this.connectorData.previousOutcomes = v.previousOutcomes || [];
                this.connectorData.description = v.description || "";
                this.connectorData.label = v.label || this.$t("diagrams.components.setTarget.untitledConnector");
                this.connectorData.submissionOption = v.submissionOption || "OPTIONAL";
                this.$store.commit("diagrams/checkConnectorsUUIDs", v);
            }
        }
    },
    created() {
        this.$root.$on("connectorAddedDeleted", () => {
            this.connectorOrderChanged();
        });
        if (this.isHumanTask) {
            this.preselectedTarget = this.diagramConfigData.content.find(el => el.uuid === this.selectedPluginUuid).preselectedTarget || false;
        }
    },
    mounted() {
        this.$store.dispatch("admin/getMembersLoadSearch", {});
    },
    activated() {
        let currentMappedProcess = "";
        if (this.selectedPluginConfigData.process) {
            currentMappedProcess = this.selectedPluginConfigData.process.processId;
            if (this.selectedPluginConfigData.pluginType === "PROCESS_PLUGIN") {
                this.showOutcomesContainer = !this.selectedPluginConfigData.process.isAsync;
            }
        }

        this.getOutcomePoints = [];
        if (currentMappedProcess) {
            this.showInfoMessage = "";
            this.$store.dispatch("diagrams/getProcessEndpoints", currentMappedProcess).then(data => {
                if (data.data && data.data.length) {
                    this.noEndpointsAvailable = false;
                    data.data.forEach(item => {
                        this.getOutcomePoints.push({
                            label: item.label,
                            svgIcon: this.getTargetIcon(item.pluginType),
                            value: item.uuid
                        });
                    });
                } else {
                    this.noEndpointsAvailable = true;
                    this.showInfoMessage = this.$t("diagrams.components.setTarget.noEndpointAvailable");
                }
            });
        } else {
            this.showInfoMessage = this.$t("diagrams.components.setTarget.noProcessSelected", { processName: this.selectedPluginConfigData.label });
        }
    },
    beforeDestroy() {
        this.$root.$off("connectorAddedDeleted");
    },
    methods: {
        ...mapMutations("diagrams", ["setLastPluginCreated", "setConnectorsValidation", "checkConnectorsUUIDs"]),
        setPluginIcon,
        connectorOrderChanged(connectors) {
            const parseConnectors = connectors || this.getConnectors;
            this.diagramConfigData.connectors.forEach(obj => {
                parseConnectors.forEach((elem, ind) => {
                    if (elem.uuid === obj.uuid) {
                        this.$set(obj, "submissionOrder", ind);
                    }
                });
            });
            this.$root.$emit("showCheckedSaveBtn", false);
        },
        preselectTarget() {
            const item = this.diagramConfigData.content.find(el => el.uuid === this.selectedPluginUuid);
            if (item) {
                item.preselectedTarget = this.preselectedTarget;
                this.$root.$emit("showCheckedSaveBtn", false);
            }
        },
        afterHide() {
            this.$emit("input", false);
        },
        getTargetIcon(id) {
            return { name: this.setPluginIcon({ pluginType: id }) };
        },
        currentValue() {
            let dataToSend = "";
            if (this.activeConnector && this.activeConnector.to && this.activeConnector.to.uuid) {
                dataToSend = this.activeConnector.to.uuid;
            }
            return dataToSend;
        },
        action(action) {
            if (action === "close") {
                let oldLabel;
                const { label = "" } = this.selectedConnectorInitialValue || {};
                const { label: currentLabel } = this.connectorData;
                if (label !== currentLabel) {
                    oldLabel = { label };
                }

                if (this.saveEnabled && !this.readonly) {
                    this.targetDlg = true;
                } else {
                    this.hide(oldLabel);
                }
            } else if (action === "primary") {
                this.$v.connectorData.$touch();
                if (!(this.$v.connectorData.$error && this.activeConnector.to.uuid)) {
                    if (!this.activeConnector.uuid || (this.initialConnectorData !== this.activeConnector.uuid)) {
                        if (this.initialConnectorData) {
                            this.deleteConnector(this.initialConnectorData, true);
                        }
                        if (this.activeConnector.to.uuid) {
                            this.addConnectorToDiagram().then(() => {
                                this.diagramConfigData.connectors.forEach(obj => {
                                    if (this.activeConnector.uuid === obj.uuid) {
                                        obj.submissionOrder = this.getConnectors.length - 1;
                                    }
                                });
                                this.save();
                                this.hide();
                            });
                        } else {
                            this.targetSaved = true;
                            this.hide();
                        }
                    } else {
                        this.save();
                        this.hide();
                    }
                }
            } else if (action === this.$t("diagrams.components.setRules.delete")) {
                this.deleteConnector(this.activeConnector.uuid);
                this.resetSelectedTarget = true;
                setTimeout(() => {
                    this.resetSelectedTarget = false;
                    this.saveEnabled = true;
                }, 0);
            }
            this.selectedConnectorInitialValue = null;
        },
        save(oldLabel, resetData) {
            const { uuid } = this.activeConnector;
            const payload = this.connectorData;
            this.targetSaved = true;
            if (oldLabel) {
                payload.label = oldLabel.label;
            }
            if (resetData) {
                this.resetConnectorData();
            }
            Object.entries(payload).forEach(([property]) => {
                this.$store.commit("diagrams/setConfigData", {
                    uuid, value: payload[property], property, type: "connector"
                });
                if (property === "label") {
                    eventBus.$emit("addConnectorLabel", { uuid, label: payload.label });
                }
            });
        },
        hide(oldLabel) {
            if (!this.targetSaved && this.selectedConnectorInitialValue && !this.readonly) {
                this.activeConnector = this.selectedConnectorInitialValue;
                if (this.activeConnector) {
                    this.addConnectorToDiagram().then(() => {
                        this.save(oldLabel, true);
                    });
                }
            } else {
                this.resetConnectorData();
            }
        },
        resetConnectorData() {
            this.targetSaved = false;
            this.saveEnabled = false;
            this.modalOpened = false;
            this.activeConnector = null;
        },
        addConnectorToDiagram() {
            const vm = this;
            const to = vm.activeConnector.to.uuid;

            return new Promise((resolve) => {
                eventBus.$emit("addConnector", {
                    from: this.uuid,
                    to,
                    callback(uuid) {
                        vm.activeConnector.uuid = uuid;
                        vm.activeConnector.to = { ...vm.getToObjectConfig(to) };
                        vm.activeConnector.from = vm.uuid;
                        resolve();
                    }
                });
            });
        },
        deleteConnector(uuid, fromSave) {
            if (uuid) {
                eventBus.$emit("deleteConnector", uuid);
            }
            this.diagramConfigData.connectors.forEach((obj, i) => {
                if (obj.uuid === this.activeConnector.uuid) {
                    this.diagramConfigData.connectors.splice(i, 1);
                }
            });
            this.connectorOrderChanged();
            if (!fromSave) {
                this.activeConnector.to.uuid = "";
                this.initialConnectorData = "";
                this.saveEnabled = true;
            }
        },
        addNewTarget() {
            this.initialConnectorData.submissionOption = "OPTIONAL";
            this.activeConnector = {
                uuid: "",
                to: {
                    uuid: ""
                },
                label: this.$t("diagrams.components.setTarget.untitledConnector"),
                from: this.uuid,
                description: "",
                statusNameCode: {
                    statusCode: "",
                    statusName: ""
                },
                notifications: [],
                notificationRules: [],
                approvalDecision: [],
                previousOutcomes: [],
                submissionOption: "OPTIONAL"
            };
            this.modalOpened = true;
            this.checkAvailableEndpoints();
            this.firstLoadModal = true;
        },
        setValue(v, connector, type) {
            this.saveEnabled = true;
            if (type === "label" && !v) {
                if (!v) {
                    this.connectorData[type] = this.$t("diagrams.components.setTarget.untitledConnector");
                } else {
                    this.connectorData[type] = v;
                    connector.label = this.connectorData[type];
                }
            } else {
                this.connectorData[type] = v;
            }
            if (v && connector) {
                this.$store.commit("diagrams/checkConnectorsUUIDs", connector);
            }
        },
        valueSelected(val) {
            if (!this.firstLoadModal) {
                const newValue = val && val[0] ? val[0].value : "";
                this.activeConnector.uuid = newValue ? "" : this.activeConnector.uuid;
                this.activeConnector.to.uuid = newValue || this.activeConnector.to.uuid;
                this.saveEnabled = !!newValue;
            }
        },
        outcomeValueSelected(val) {
            if (!this.firstLoadModal) {
                this.saveEnabled = true;
            }
            const outcomesToSend = [];
            if (val.length) {
                this.noOutcomeSelected = false;
                val.forEach(item => {
                    outcomesToSend.push(item.value);
                });
            } else {
                this.noOutcomeSelected = true;
            }
            this.connectorData.previousOutcomes = outcomesToSend || this.connectorData.previousOutcomes;
        },
        afterShow() {
            this.firstLoadModal = false;
            if (this.activeConnector.to.uuid && this.selectedPluginCode === "APPROVAL_PLUGIN" && this.editedTarget) {
                this.saveEnabled = false;
            }
            this.editedTarget = false;
        },
        getRulesNotif(value) {
            if (value && value.length) {
                this.connectorData.notificationRules = value;
            } else {
                this.connectorData.notificationRules = [];
            }
        },
        rulesDefined(value) {
            this.saveEnabled = value;
        },
        getToObjectConfig(uuid) {
            return this.$store.getters["diagrams/pluginConfigData"](uuid, "content");
        },
        saveNotification(notification) {
            let found = false;
            this.saveEnabled = true;
            if (!this.connectorData.notifications) {
                this.connectorData.notifications = [];
            }
            const savedNotifications = this.connectorData.notifications;

            for (let i = 0; i < savedNotifications.length; i++) {
                const el = savedNotifications[i];

                if (el.id === notification.id) {
                    found = true;
                    Object.entries(notification).forEach(([key]) => {
                        savedNotifications[i][key] = notification[key];
                    });

                    break;
                }
            }
            if (!found) {
                savedNotifications.push(notification);
            }
            this.saveEnabled = true;
        },
        selectConnector(connector) {
            this.modalOpened = true;
            this.firstLoadModal = true;
            this.editedTarget = true;
            // do a deep copy
            this.activeConnector = JSON.parse(JSON.stringify(connector));
            this.selectedConnectorInitialValue = JSON.parse(JSON.stringify(connector));
            this.initialConnectorData = connector.uuid;
            this.connectorData.label = connector.label || this.$t("diagrams.components.setTarget.untitledConnector");
            this.connectorData.description = connector.description || "";
            this.connectorData.notifications = connector.notifications || [];
            this.connectorData.submissionOption = connector.submissionOption || "OPTIONAL";
            this.checkAvailableEndpoints();
        },
        deleteNotification(id) {
            const indexId = this.connectorData.notifications.findIndex(element => element.id === id);
            this.connectorData.notifications.splice(indexId, 1);
            this.saveEnabled = true;
        },
        checkAvailableEndpoints() {
            if (this.selectedPluginConfigData.process && this.selectedPluginConfigData.process.processId && this.getOutcomePoints.length) {
                this.outcomesAlreadyMapped = [];
                this.allEndpointsAlreadySelected = false;
                this.showInfoMessage = "";
                this.diagramConfigData.connectors.forEach(el => {
                    if (el.from === this.selectedPluginUuid && el.previousOutcomes
                && el.previousOutcomes.length && el.uuid !== this.activeConnector.uuid) {
                        this.outcomesAlreadyMapped.push(...el.previousOutcomes);
                    }
                });
                this.outcomePointsFiltered = this.getOutcomePoints.filter(el => !this.outcomesAlreadyMapped.includes(el.value));
                if (!this.outcomePointsFiltered.length) {
                    this.allEndpointsAlreadySelected = true;
                    this.showInfoMessage = this.$t("diagrams.components.setTarget.allEndpointsSelected");
                }
            }
        }
    }
};
